import './SpinnerLoader.css'

const SpinnerLoader = ({ message = "Loading…", minHeight = "200px" }) => (
  <div className="content__loading" style={{ minHeight }}>
    <div className="content__spinner" />
    {message && <span>{message}</span>}
  </div>
);

export default SpinnerLoader;
